import { QrCamera, cameraAvailable } from '../PassageCheckIn/camera';
import { quickToken } from './quick-token';

const quickMessage = document.getElementById('quick-message')!;
const quickScan = document.getElementById('quick-scan') as HTMLButtonElement;
const quickStop = document.getElementById('quick-stop') as HTMLButtonElement;
const quickCameras = document.getElementById('quick-cameras') as HTMLSelectElement;
let quickBusy = false;
const quickCamera = new QrCamera(document.getElementById('quick-camera') as HTMLVideoElement,
    quickCameras, quickStop, quickScan, quickMessage, code => { void quickLogin(code); });
async function quickLogin(code: string) {
    if (quickBusy) return;
    let token = quickToken(code, location.origin);
    if (!token) { quickMessage.textContent = '簡単ログイン用QRを読み取ってください。'; return; }
    quickBusy = true;
    quickCamera.stop();
    quickScan.disabled = true;
    quickMessage.textContent = 'ログインを確認しています。';
    try {
        const body = new URLSearchParams({ token,
            __RequestVerificationToken: (document.querySelector('#quick-login-area input[name="__RequestVerificationToken"]') as HTMLInputElement).value });
        const response = await fetch('/QuickLogin/Authenticate', {method:'POST', body, cache:'no-store'});
        if (!response.ok) throw new Error();
        const result = await response.json();
        if (result.Result) location.replace(result.SecondAuth ? '/Login/SecondAuth' : '/');
        else quickMessage.textContent = result.Message;
    } catch { quickMessage.textContent = 'ログインできませんでした。もう一度読み取ってください。'; }
    finally { token = ''; quickBusy = false; quickScan.disabled = false; }
}
quickScan.addEventListener('click', () => { void quickCamera.start(); });
// HTTPSでない環境ではカメラを使えないため、読取りボタン自体を出さない。
if (!cameraAvailable()) {
    quickScan.hidden = true;
    quickStop.hidden = true;
    quickCameras.hidden = true;
    quickMessage.textContent = 'この環境ではカメラを使えません。ユーザコードとパスワードでログインしてください。';
}
quickStop.addEventListener('click', () => quickCamera.stop());
quickCameras.addEventListener('change', () => { void quickCamera.start(quickCameras.value); });
window.addEventListener('pagehide', () => quickCamera.stop());
if (location.hash.startsWith('#quick-login=')) {
    const credentialUrl = location.href;
    history.replaceState(null, '', location.pathname + location.search);
    void quickLogin(credentialUrl);
}

// Login/Index.ts
// Whitelist-style validation: accept only in-app relative paths starting with a
// single '/'. This rejects protocol-relative URLs ('//host/...'), absolute URLs
// ('http://...', 'javascript:...'), backslashes, and control characters so that
// the value is safe to assign to document.location.href.
function getSafeReturnUrl(raw: string): string {
    if (!raw) return '';
    if (!/^\/[A-Za-z0-9_\-./?#&=%~+:@!$'(),;[\]]*$/.test(raw)) return '';
    if (raw.startsWith('//')) return '';
    return raw;
}

$('#togglePassword').on('click touch', function () {
    const $btn = $(this);
    const $pwd = $('#password');
    const $icon = $btn.find('i');
    const show = $pwd.attr('type') === 'password';
    $pwd.attr('type', show ? 'text' : 'password');
    $icon.toggleClass('fa-eye', !show).toggleClass('fa-eye-slash', show);
    $btn.attr('aria-pressed', show ? 'true' : 'false');
});

$('#loginButton').on('click touch', function () {
    $.ajax({
        url: '/api/auth/auth',
        type: 'post',
        data: {
            UserCode: $('#userCode').val(),
            Password: $('#password').val(),
        },
        dataType: 'json',
    })
        .done(function (result) {
            const rawReturnUrl = (($('#returnUrl').val() as string) || '').trim();
            const safeReturnUrl = getSafeReturnUrl(rawReturnUrl);
            if (result.Result && result.SecondAuth) {
                const secondAuthUrl = safeReturnUrl
                    ? '/login/secondAuth?returnUrl=' + encodeURIComponent(safeReturnUrl)
                    : '/login/secondAuth';
                document.location.href = secondAuthUrl;
            } else if (result.Result && !result.SecondAuth) {
                document.location.href = safeReturnUrl || '/';
            } else {
                bootbox.alert(result.Message);
            }
        })
        .fail(function () {
            bootbox.alert('ログインに失敗しました');
        });
});
